import React from "react";
import MainLayout from "../../layouts/MainLayout";
import LeadFormEmbeddedPage from "../../modules/LeadForm/LeadFormEmbeddedPage";
import { DESTINATION_WEDDING_MODEL } from "../../constants/constants";
import { getGetQuotePageHeader } from "../../util/seoUtil";
import SyncNextStyleHead from "../../components/seo/SyncNextStyleHead";

function GetQuotePageDestinationRajasthan() {
  return (
    <MainLayout>
      <SyncNextStyleHead>{getGetQuotePageHeader()}</SyncNextStyleHead>
      <LeadFormEmbeddedPage overRideForm="rajasthan" leadFormMode={DESTINATION_WEDDING_MODEL} />
    </MainLayout>
  );
}

export default GetQuotePageDestinationRajasthan;
